import React, { useEffect } from 'react';
import Bio from './Bio';
import Banner from './Banner';
import ScrollToTopButton from '../../component/ScrollToTopButton';

import 'animate.css';

function About() {
  // This hook correctly handles scrolling to a team member if a URL hash is present.
  // No changes are needed here.
  useEffect(() => {
    if (window.location.hash) {
      const hash = window.location.hash.slice(1);
      const target = document.getElementById(hash);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, []);

  return (
    <main>
      <Banner />
      <Bio />
      <ScrollToTopButton />
    </main>
  );
}

export default About;
